import React from 'react';
import {observer} from 'mobx-react';
import {types, withState} from 'shared/core';
import {InteractiveTable, DropdownFilter} from 'components';
import {Goal} from 'stores/performance_goals';
import GoalItem from './GoalItem';
import {GoalListState} from '../state';
import EditGoalModal from './EditGoalModal';

const COLUMNS = [
  {
    component: GoalItem,
    width: 11
  }
];

const LOCALIZATION = {
  interactive: {
    addModel: 'goals.Create Goal'
  },
  removeModal: {
    header: 'goals.Remove Goal?',
    subHeader: 'goals.Are you sure you want to delete this goal?',
    body: 'goals.This goal and all the associated comments and progress updates will be deleted forever.'
  },
};

const GoalList = observer(({uiState, title, endpoint}) => {
  const {canCreateGoals, statusOptions, timePeriodOptions} = uiState;

  return (
    <React.Fragment>
      <InteractiveTable
        saveStateToUrl
        title={title}
        onAdd={canCreateGoals ? () => uiState.addGoal() : null}
        columns={COLUMNS}
        localization={LOCALIZATION}
        showRoute={model => `/${model.id}/view${window.location.search}`}
        showLinks={true}
        customLinks={goal => uiState.customLinksFor(goal)}
        onEdit={goal => uiState.openEditGoalModal(goal)}
        onRemove={goal => uiState.deleteGoal(goal)}
        showHeaders={false}
        onMount={agent => uiState.setAgent(agent)}
        proxy={{
          type: 'async',
          modelType: types.PERFORMANCE_GOALS.GOAL,
          model: Goal,
          endpoint: endpoint
        }}
      >
        <DropdownFilter attr='time_period' defaultFilter={1} options={timePeriodOptions}/>
        <DropdownFilter attr='status' options={statusOptions}/>
      </InteractiveTable>
      <EditGoalModal uiState={uiState}/>
    </React.Fragment>
  );
});

export default withState(GoalList, GoalListState);
